import { datetime } from '@common/services';

const ISO_DATE = 'YYYY-MM-DD';

export function organizationTodayIso(
  timeZone?: string | null,
  now: ReturnType<typeof datetime> = datetime()
): string {
  return timeZone ? now.tz(timeZone).format(ISO_DATE) : now.format(ISO_DATE);
}
